import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";

import { Button } from "@material-ui/core";
import { Card, CardBody } from "../../../../_metronic/_partials/controls";
import MultiTabBlock from "../../../components/MultiTabBlock";


import DataroomTab from "../../../components/dataRoom/DataRoomTab";
import DealDocument from "../deals/DealDocument";
import QAPrivateTab from "./QAPrivateTab";
import ServiceOfferTab from "./ServiceOfferTab";

export default function WatchDealAdvisorPage() {

    const history = useHistory();
    const {
        isLoading: isLoadingData,
        disableLoading: disableLoadingData,
        ContentSkeleton
    } = useSkeleton();


    const infoAdvisor = JSON.parse(localStorage.getItem("advisorDeal"));

    useEffect(() => {

        if (!infoAdvisor) {
            disableLoadingData();
            return;
        }

        disableLoadingData();

    }, [disableLoadingData, infoAdvisor]);


    function getMultiTabColumns() {
        const columnsTab = ["Service Offer", "NDA", "Dataroom", "Contract", "Q&A"]

        return columnsTab;
    }


    const renderMultiTabContent = tabName => {
        if (tabName === "Service Offer") {
            return <ServiceOfferTab offer={infoAdvisor?.offer} />;
        }
        else if (tabName === "NDA") {
            return <DealDocument document={infoAdvisor?.nda?.doc} signed={infoAdvisor?.nda?.status !== "not signed"} envelopedId={infoAdvisor?.nda?.envelopedId} />
        }
        else if (tabName === "Dataroom") {
            return <DataroomTab id={infoAdvisor?.pathId} path={infoAdvisor?.path} />
        }
        else if (tabName === "Contract") {
            return <DealDocument document={infoAdvisor?.contract?.doc} signed={infoAdvisor?.contract?.status && infoAdvisor?.contract?.status !== "not signed"} envelopedId={infoAdvisor?.contract?.envelopedId} />
        }
        else if (tabName === "Q&A") {
            return <QAPrivateTab questions={infoAdvisor?.faqs} />;
        }
    }

    if (isLoadingData)
        return <ContentSkeleton />;

    return (
        <>
            <Card>
                <CardBody>
                    <div className="d-flex align-item-center">
                        <div className="col-12">
                            <MultiTabBlock multiTabContent={renderMultiTabContent} columns={getMultiTabColumns()} step={infoAdvisor?.currentStep} />
                        </div>
                    </div>
                </CardBody>
            </Card>

            <Button
                onClick={() => history.push("/advisorDeals")}
                variant="outlined"
                style={{ marginRight: 20 }}
            >
                Back
            </Button>
        </>
    );
}